export default __webpack_public_path__ + "static/media/Bild1.cb643205.png";